import { Link } from 'react-router-dom';
import { formatNumber } from '@/shared/domain/format';
import { useT } from '@/shared/i18n/useT';

export interface BcvChipProps {
  /** Bs por dólar. Sin tasa (null) el chip no se muestra. */
  tasa: number | null;
}

/** Tasa BCV en la barra superior, en pequeño: lleva a Inicio, donde vive la Pizarra. */
export function BcvChip({ tasa }: BcvChipProps) {
  const { t, lang } = useT();
  if (tasa === null || !Number.isFinite(tasa)) return null;
  const value = formatNumber(tasa, { min: 2, max: 2, lang });
  return (
    <Link
      to="/"
      title={t('aria.bcvLink', { tasa: value })}
      className="flex h-9 items-center gap-1.5 rounded-md border border-border-soft bg-card px-2.5 shadow-elev-1 transition-colors duration-fast ease-standard hover:border-border"
    >
      <span className="text-xs font-semibold uppercase tracking-wider text-fg-muted">BCV</span>{' '}
      <span className="num text-sm font-semibold text-fg">{value}</span>
      <span className="sr-only"> {t('aria.bcvUnit')}</span>
    </Link>
  );
}
